import React from 'react';
import marked from 'marked';

import Modal from 'Components/Partials/Modal/Modal';
import ModalHeader from 'Components/Partials/Modal/ModalHeader';
import ModalBody from 'Components/Partials/Modal/ModalBody';
import Loading from 'Components/Partials/Layouts/Loading';
import RenderWYSIWYG from "Components/Partials/Layouts/RenderWYSIWYG";

export default class VersionNotes extends React.Component {
    /**
     * @var state
     * @type {{markdown: null}}
     */
    state = {
        markdown: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        const notesPath = require('../../../../../version-notes.md');

        this.setState({
            markdown: marked(notesPath)
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {markdown} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Version Notes
                </ModalHeader>

                <ModalBody>
                    <div className="version">
                        {markdown && (
                            <RenderWYSIWYG content={markdown} />
                        )}

                        {!markdown && (<Loading/>)}
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
